import { Injectable } from "@angular/core";
import { MoreNavigationLinkExtension } from "@geolib/geoappbase-client";

@Injectable({ providedIn: "root" })
export default class GeobusCourseProgramLinkExtension extends MoreNavigationLinkExtension {

    public isEnabled(): boolean {
        return true;
    }

    public get title(): string {
        return "APPNAVIGATION.COURSE_PROGRAM";
    }

    public get linkUrl(): string {
        return "https://www.geoinfo.ch/loesungen/schulungen/";
    }

    public get statisticEvent(): string {
        return "courseprogram";
    }
}
